import React from 'react';

const Root = ({ children }) => {
    return (
        <div id='rootElement' className='Root-Element' canvas>
            {children}
        </div>
    )
};

export default Root;
